import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { 
  UserTermsConditionsService 
} from '@app/services/api/user-terms-conditions/user-terms-conditions.service';
import { UserService } from '@app/services/api/user/user.service';
import { analytics } from '@app/events/segment/analytics';
import { finalize } from 'rxjs';

@Component({
  selector: 'app-terms-conditions',
  imports: [
    CommonModule,
  ],
  templateUrl: './terms-conditions.component.html',
  styleUrl: './terms-conditions.component.css'
})
export class TermsAndConditionsComponent {
  public loader: boolean = false;
  public loadingMessage: string = '';

  constructor(
    public userTermsService: UserTermsConditionsService,
    private router: Router,
    private userService: UserService,
  ) {}

  onClickTermsConditions() {
    this.loader = true;
    this.loadingMessage = 'Accepting terms, please wait…';
    
    // Track terms acceptance event
    analytics.track('Terms Accepted', {
      section: 'onboarding',
      timestamp: new Date().toISOString(),
    });

    this.userTermsService.saveUserTermsConditionsAcceptance().pipe(
      finalize(() => this.loader = false)
    ).subscribe({
      next: () => {
        this.loadingMessage = 'Terms accepted.';
        // Invalidate the /me cache so the guard sees termsAccepted: true
        this.userService.invalidateMeCache();
        this.router.navigate(['/user-info']);
      },
      error: (error) => {
        this.loadingMessage = 'Failed to accept terms. Please try again.';
        console.error('Error saving user terms:', error);
      }
    });
  }
}
